<template>
  <div class="page-container">
<div>
<van-nav-bar :title="$t('video.video')" style="background:unset;color:#000">
<template #left>
<van-icon name="arrow-left" size="22" color="#000"  @click="onClickLeft()"/>
</template>
<!-- <template #right>
<van-icon name="chat-o" size="24" color="#000" @click="$router.push({path:'/Notice'});" />
</template> -->
</van-nav-bar>
</div>

    <van-tabs
      v-model="active"
       title-inactive-color="rgb(68, 40, 137)"
              title-active-color="rgb(197, 113, 207)"
      line-width="40PX"
      line-height="10PX"
      @change="onTabChange"
    >
      <van-tab
        v-for="(item, index) in videolitem"
        :key="item.id"
        :name="item.id"
      >
        <template #title>
          <div class="tab-title" :class="{ 'has-new-badge': index === 0 }">
            <span class="tab-text">{{ item.name }}</span>
            <img 
              v-if="index === 0" 
              src="/img/new.png" 
              class="new-badge" 
              alt="new"
            />
          </div>
        </template>
        
        <van-pull-refresh 
          v-model="refreshing" 
          @refresh="onRefresh"
        >
          <van-list
            v-model="loading"
            :finished="finished"
            :finished-text="$t('video.no_more')"
            @load="onLoad"
          >
            <div class="movie-grid">
              <div 
                class="movie-card" 
                v-for="movie in data" 
                :key="movie.id"
                @click="toPlayVideo(movie.id)"
              >
                <div class="cover-wrapper">
                  <img 
                    :src="movie.vod_pic" 
                    :alt="movie.vod_name"
                    class="cover-img"
                    loading="lazy"
                  />
                  <div class="movie-info">
                    <span class="movie-name">{{ movie.vod_name }}</span>
                    <span class="play-count">
                      {{ $t("video.play") }}: {{ movie.count }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { Toast } from "vant";

export default {
  name: "VideoList",
  data() {
    return {
      active: 5,
      loading: false,
      finished: false,
      refreshing: false,
      videolitem: [],
      data: [],
      page: 0,
      pageSize: 12,
      currentTabId: 5,
      isLoadingMore: false
    };
  },
  
  watch: {
    active(val) {
      this.currentTabId = val;
    }
  },
  
  created() {
    this.fetchVideoCategories();
  },
  
  mounted() {
    if (this.videolitem.length === 0) {
      this.fetchVideoCategories();
    }
  },

  methods: {
    async fetchVideoCategories() {
      try {
        const res = await this.$http({
          method: "get",
          url: "video_class",
          params: {} 
        });
        
        console.log('Categories response:', res);
        
        if (res.data && Array.isArray(res.data)) {
          const lang = localStorage.getItem("lang") || 'zh';
          
          // 处理返回的分类数据
          this.videolitem = res.data.map(item => ({
            id: item.id,
            name: this.getLocalizedName(item.name, lang)
          }));
          
          // 添加"最新"标签到最前面
          this.videolitem.unshift({
            id: 5,
            name: this.getLocalizedName("最新,new,最新の,new", lang)
          });
          
          // 确保active指向第一个标签
          if (this.videolitem.length > 0) {
            this.active = this.videolitem[0].id;
            this.currentTabId = this.videolitem[0].id;
          }
          
          console.log('videolitem:', this.videolitem);
        } else {
          console.error('分类数据格式错误:', res.data);
          // 如果数据格式不对，设置默认分类
          const lang = localStorage.getItem("lang") || 'zh';
          this.videolitem = [{
            id: 5,
            name: this.getLocalizedName("最新,new,最新の,new", lang)
          }];
        }
      } catch (error) {
        console.error("获取视频分类失败:", error);
        Toast.fail("Category loading failed");
      }
    },

    getLocalizedName(nameStr, lang) {
      if (!nameStr) return 'Unnamed';
      
      const names = String(nameStr).split(",");
      const langMap = {
        kr: 0,
        en: 1, 
        ja: 2,
        zh: 3
      };
      
      const index = langMap[lang] !== undefined ? langMap[lang] : 3;
      return names[index] || names[0] || 'Unnamed';
    },

    async onLoad() {
      if (this.isLoadingMore) return;
      
      this.isLoadingMore = true;
      this.loading = true;
      
      try {
        const res = await this.fetchVideoList();
        
        if (res && res.length > 0) {
          this.data = [...this.data, ...res];
          this.page++;
        } else {
          this.finished = true;
        }
      } catch (error) {
        console.error("加载视频列表失败:", error);
        Toast.fail("加载失败");
      } finally {
        this.loading = false;
        this.isLoadingMore = false;
        
        if (this.refreshing) {
          this.refreshing = false;
          Toast.success("Refresh successful");
        }
      }
    },

    fetchVideoList() {
      return this.$http({
        method: "get",
        url: "video_list",
        data: { 
          id: this.currentTabId, 
          page: this.page 
        },
      }).then(res => {
        console.log('Video list response:', res);
        
        const responseData = res.data;
        
        if (responseData && Array.isArray(responseData)) {
          return responseData;
        } else if (responseData && responseData.data) {
          return Array.isArray(responseData.data) ? responseData.data : [];
        } else if (responseData && responseData.list) {
          return Array.isArray(responseData.list) ? responseData.list : [];
        }
        
        return [];
      }).catch(error => {
        console.error("视频列表请求失败:", error);
        throw error;
      });
    },

    onTabChange(name) {
      this.currentTabId = name;
      this.active = name;
      this.resetAndReload();
    },

    onRefresh() {
      this.resetAndReload();
    },

    resetAndReload() {
      this.finished = false;
      this.loading = true;
      this.page = 0;
      this.data = [];
      this.onLoad();
    },

    toPlayVideo(id) {
      if (!id) {
        console.error('Invalid video ID');
        return;
      }
      
      this.$router.push({ 
        path: "/PlayVideo", 
        query: { id } 
      });
    },

    onClickLeft() {
      this.$router.push({ path: "/Game" });
    }
  }
};
</script>

<style scoped lang="less">
.page-container {
  width: 100%;
  min-height: 100vh;
  padding-bottom: 4.33333rem;
  background: url("/img/home/g.f7e76bcc.png") repeat top / 100% auto;
  position: relative;
}

.nav-bar {
  background: linear-gradient(30deg, #7d76ef, #d63f8c);
  
  :deep(.van-nav-bar__title) {
    color: #000;
    font-weight: 600;
  }
  
  :deep(.van-nav-bar__left) {
    color: #000;
  }
}

.video-tabs {
  margin-top: 10PX;
  
  :deep(.van-tabs__wrap) {
    height: 80PX;
    padding: 0;
    background: transparent;
  }
  
  :deep(.van-tabs__nav) {
    background: transparent;
    display: flex;
    align-items: center;
  }
  
  :deep(.van-tabs__line) {
    background-color: #c571cf;
    height: 5PX;
    border-radius: 5PX;
    bottom: 10PX;
    width: 30PX !important;
  }
  
  :deep(.van-tab) {
    font-size: 22PX;
    height: 60PX;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    padding: 0 20PX;
  }
  
  :deep(.van-tab--active) {
    .tab-text {
      font-weight: bold;
    }
  }
}

.tab-title {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  line-height: 1;
  
  .tab-text {
    display: inline-block;
    font-size: 22PX;
    line-height: 1;
    position: relative;
    z-index: 2;
  }
  
  .new-badge {
    position: absolute;
    right: -28PX;
    top: -18PX;
    width: 32PX;
    height: 16PX;
    object-fit: contain;
    pointer-events: none;
    z-index: 1;
    transform: rotate(-10deg);
  }
  
  &.has-new-badge {
    .tab-text {
      font-weight: bold;
      color: #c571cf;
    }
  }
}

:deep(.van-tab:first-child) {
  .tab-title {
    position: relative;
    
    .new-badge {
      position: absolute;
      right: -28PX;
      top: -18PX;
      width: 32PX;
      height: 16PX;
      transform: rotate(-10deg);
    }
  }
}

.movie-grid {
  display: flex;
  flex-wrap: wrap;
  padding: 10PX;
  gap: 10PX;
}

.movie-card {
  width: calc(50% - 5PX);
  cursor: pointer;
  transition: transform 0.2s;
  
  &:active {
    transform: scale(0.98);
  }
}

.cover-wrapper {
  position: relative;
  border-radius: 8PX;
  overflow: hidden;
  box-shadow: 0 4PX 12PX rgba(0, 0, 0, 0.1);
}

.cover-img {
  width: 100%;
  aspect-ratio: 16/9;
  object-fit: cover;
  display: block;
  transition: transform 0.3s;
  
  &:hover {
    transform: scale(1.05);
  }
}

.movie-info {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 8PX;
  background: linear-gradient(to top, rgba(0,0,0,0.8), transparent);
  color: #fff;
  
  .movie-name {
    display: block;
    font-size: 14PX;
    font-weight: 500;
    margin-bottom: 4PX;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  
  .play-count {
    font-size: 12PX;
    opacity: 0.9;
  }
}

@media (max-width: 768PX) {
  .movie-card {
    width: calc(50% - 5PX);
  }
  
  .movie-info {
    .movie-name {
      font-size: 12PX;
    }
    
    .play-count {
      font-size: 10PX;
    }
  }
  
  .video-tabs {
    :deep(.van-tabs__wrap) {
      height: 70PX;
    }
    
    :deep(.van-tab) {
      font-size: 18PX;
      height: 50PX;
      padding: 0 15PX;
    }
  }
  
  .tab-title {
    .tab-text {
      font-size: 18PX;
    }
    
    .new-badge {
      width: 28PX;
      height: 14PX;
      right: -25PX;
      top: -15PX;
    }
  }
}

@media (min-width: 769PX) {
  .movie-grid {
    gap: 15PX;
  }
  
  .movie-card {
    width: calc(25% - 15PX);
  }
  
  .video-tabs {
    :deep(.van-tabs__wrap) {
      height: 90PX;
    }
    
    :deep(.van-tab) {
      font-size: 24PX;
      height: 70PX;
      padding: 0 25PX;
    }
  }
  
  .tab-title {
    .tab-text {
      font-size: 24PX;
    }
    
    .new-badge {
      width: 36PX;
      height: 18PX;
      right: -30PX;
      top: -20PX;
    }
  }
}
/deep/ .van-tabs__wrap {
  height: 13vw;
  padding-bottom: 10px;
}
/deep/ .van-tabs__line {
  background-color: #c571cf;
}
/deep/ .van-nav-bar__title{
	color:#000
}
/deep/ .van-loading__text {
  font-size: 32px;
  color: #000;

}
/deep/ .van-tabs__nav{
	background: unset;
}
/deep/ .van-list__finished-text {
  font-size: 32px;
  color: #000;

}
/deep/ .van-pull-refresh__head {
  height: 100px;
}
/deep/ .van-pull-refresh__text {
  font-size: 32px; /* 设置字体大小 */
  color: #000;
 
}
</style>